<template>
  <b-container fluid class="icons-section overflow-hidden">
    <b-container>
      <b-row class="align-items-center">
        <b-col lg="4" class=" animated wow fadeInUp" data-wow-delay="0ms">
          <div class="icon-container">
            <div class="icon-box">
              <font-awesome-icon icon="cogs" />
            </div>
            <div class="icon-text">
              <b>Najwyższa jakość</b>
              <p>Kupując u nas możesz być pewien że kupujesz produkt najwyższej jakości. Nie oszczędzamy na materiale.</p>
            </div>
          </div>
        </b-col>
        <b-col lg="4" class=" animated wow fadeInUp" data-wow-delay="200ms">
          <div class="icon-container">
            <div class="icon-box">
              <font-awesome-icon icon="lightbulb" />
            </div>
            <div class="icon-text">
              <b>Kupujesz oryginał</b>
              <p>Sami projektujemy i&nbsp;konstruujemy maszyny więc jesteśmy o krok przed konkurencją, która kopiuje nasze rozwiązania.</p>
            </div>
          </div>
        </b-col>
        <b-col lg="4" class=" animated wow fadeInUp" data-wow-delay="400ms">
          <div class="icon-container">
            <div class="icon-box">
              <font-awesome-icon icon="thumbs-up" />
            </div>
            <div class="icon-text">
              <b>Zadowoleni klienci</b>
              <p>Nasze nacinarki cieszą się uznaniem wśród szerokiej rzeszy klientów z powodu swojej trwałości, precyzji i&nbsp;łatwej obsługi.</p>
            </div>
          </div>
        </b-col>
      </b-row>
    </b-container>
  </b-container>
</template>

<script>
export default {
  name: 'Icons',
  components: {}
}
</script>

<style lang="scss" scoped>
.icons-section {
  background: #479cc8;
  color: white;
  padding: 100px 0;
}
.icon-container {
  display: flex;
  height: 100%;
  align-items: center;
  margin: 15px 0;
}
.icon-box {
  flex: 1 0 100px;
  width: 100px;
  height: 100px;
  border: 2px solid white;
  display: flex;
  justify-content: center;
  align-items: center;
}
.icon-text {
  flex: 1 1 100%;
  font-size: 14px;
  line-height: 18px;
  margin-left:20px;
  text-align: justify;
  b {
    font-size: 24px;
    margin-bottom:10px;
    display: inline-block;
    line-height: 25px;
    text-align: left;
  }
}
.icon-text p{
  margin:0;
}

[class*="fa-"] {
  font-size: 48px;
}
</style>